var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sidebar'),_c('v-main',[_c('router-view'),_c('Snackbar'),_c('CheckToken'),_c('Loading')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }